/* ==========================================================================
   GLANTEX Bestandsanzeige - Aktualisierung beim Variantenwechsel

   Haengt sich an das BEREITS VORHANDENE Ereignis des Themes. In
   assets/theme.js steht:

       this.container.dispatchEvent(new CustomEvent('variantChange', {detail}));
       document.dispatchEvent(new CustomEvent('variant:change', {detail}));

   Genutzt wird das zweite, weil es dokumentweit liegt und detail.variant
   mitfuehrt. Es wird kein zweites Variantensystem gebaut und keine
   Auswahl-Logik nachgebaut.

   WARUM EIN EIGENER DATENBLOCK NOETIG IST

   detail.variant ist das Varianten-JSON von Shopify - und das enthaelt
   inventory_quantity NICHT. Die Menge steht nur in Liquid zur Verfuegung.
   Das Snippet gibt sie deshalb einmal serverseitig als
   <script type="application/json" data-gtx-lager-daten> aus, hier wird
   sie nur nachgeschlagen.

   Die Zustandslogik ist bewusst dieselbe wie im Snippet, damit der erste
   Aufbau und jeder spaetere Wechsel nicht auseinanderlaufen koennen.
   ========================================================================== */

(function () {
  // Die Datei wird aus einem Snippet geladen, das je Produktseite einmal
  // laeuft. Bei Schnellansicht-Modalen kann sie ein zweites Mal im
  // Dokument landen - ohne diese Sperre haengen dann zwei Zuhoerer an
  // denselben Ereignissen.
  if (window.__gtxLagerGeladen) {
    return;
  }
  window.__gtxLagerGeladen = true;

  var TEXTE = {
    av: '<strong>Auf Lager - </strong>in 1-3 Tagen bei Dir',
    low: '<strong>Geringer Bestand - </strong>in 1-3 Tagen bei Dir',
    out: '<strong>Nicht auf Lager </strong>'
  };

  function zustand(daten, schwelle) {
    // Kein Datensatz: nichts aendern, lieber den serverseitigen Stand
    // stehen lassen als raten.
    if (!daten) {
      return null;
    }

    // Bestand wird nicht verfolgt - die Variante ist unbegrenzt kaufbar.
    if (!daten.m) {
      return 'av';
    }

    // Ausdruecklich vor allem anderen: Bestand aufgebraucht heisst rot,
    // auch wenn die Variante auf "weiterverkaufen" steht und Shopify sie
    // weiterhin als verfuegbar meldet.
    if (daten.q <= 0) {
      return 'out';
    }

    return daten.q <= schwelle ? 'low' : 'av';
  }

  function aktualisiere(wurzel, variantId) {
    var block = document.querySelector('[data-gtx-lager-daten]');
    if (!block) {
      return;
    }

    var alle;
    try {
      alle = JSON.parse(block.textContent);
    } catch (e) {
      return;
    }

    var schwelle = parseInt(wurzel.getAttribute('data-schwelle'), 10) || 10;
    var neu = zustand(alle[String(variantId)], schwelle);
    if (!neu) {
      return;
    }

    wurzel.classList.remove('gtx-lager--av', 'gtx-lager--low', 'gtx-lager--out');
    wurzel.classList.add('gtx-lager--' + neu);

    var text = wurzel.querySelector('.gtx-lager__text');
    if (text) {
      text.innerHTML = TEXTE[neu];
    }
  }

  document.addEventListener('variant:change', function (evt) {
    var variante = evt.detail && evt.detail.variant;
    if (!variante || !variante.id) {
      return;
    }

    var wurzel = document.querySelector('[data-gtx-lager]');
    if (wurzel) {
      aktualisiere(wurzel, variante.id);
    }
  });
})();
